// ============================================================
// canonicalJson - JSON by value, not by the order keys were set in
// ============================================================
// Echo prevention and the write clock both ask "is this the same state?"
// by comparing JSON text (gotcha 3). JSON.stringify writes keys in
// insertion order, so one state built in two places - armour keyed in the
// body map's order by stateFromTarget, in whatever order a document came
// back from the server - reads as two different states. Two screens then
// re-write it at each other for ever: the sync loop ./dev fuzz found on
// 2026-09-28. Sorted keys make the text depend on the values alone.
//
// Arrays keep their order (a list's order is content); undefined is
// dropped exactly as JSON.stringify drops it. Pure.

/** A copy of `value` with every object's keys in sorted order, recursively. */
function sortedKeys(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortedKeys);
  if (value === null || typeof value !== 'object') return value;
  const source = value as Record<string, unknown>;
  return Object.fromEntries(
    Object.keys(source)
      .sort()
      .map((k) => [k, sortedKeys(source[k])]),
  );
}

/** JSON text that depends on the values alone, never on key order. */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(sortedKeys(value)) ?? '';
}

/** Are the two the same by value, whatever order their keys were set in? */
export function sameValue(a: unknown, b: unknown): boolean {
  return canonicalJson(a) === canonicalJson(b);
}
